import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";

import axios from "axios";
import moment from "moment";
import Dropzone from 'react-dropzone';
import swal from 'sweetalert2';
import Input from '@material-ui/core/Input';
import InputBase from '@material-ui/core/InputBase';
import FormControl from '@material-ui/core/FormControl';
import {Grid, Hidden, Button} from '@material-ui/core';
import DatePicker from 'material-ui-pickers/DatePicker';

import cross from "../../../../../assets/cross.png";
import file from "../../../../../assets/folder.png";
import downloadFile from "../../../../../assets/download-file.png";
import deleteFile from "../../../../../assets/delete.png";
import highest from "../../../../../assets/priority/highest.svg";

import urls from "../../../../../utils/urls";
import {tokenHeader} from "../../../../../utils/headers";
import Modal from "../../../../../components/modal";
import ActionButtons from "../../../common/actionButtons";
import PrioritySelect from "../../../../../components/prioritySelect";
import {ajaxHandler} from "../../../../../utils/errors";
import {fetchNotes, newNoteAdded} from "../../../../../actions/visits_actions";
import "./styles.scss";
import LoadingSpinner from "../../../../../components/spinner/Spinner";
import {dateFormat} from "../../../../../utils/formatters";


class NewNote extends Component {

    constructor(props) {
        super(props);
        let edit = this.props.notes.noteToEdit;

        let priority = edit ? edit.priority : false;
        let today = new Date();
        let tomorrow = new Date();
        tomorrow.setDate(today.getDate()+1);

        this.state = {
            categories: false,
            title: !edit ? '' : edit.title,
            private_comment: !edit ? '' : edit.private_comment,
            public_comment: !edit ? '' : edit.public_comment,
            priority,
            category: !edit ? 0 : edit.category,
            files: [],
            file_failed: false,
            showFileSection: false,
            dueDate: !edit ? null : edit.due_date?moment(edit.due_date).format("YYYY-MM-DD"):null,
            showExitModal: false,
            showDeleteModal: false,
            deletedFileIds: [],
            deleteFileId: null,

            xhr: false
        }
    }



    componentWillReceiveProps(nextProps){
        if(this.props.notes.noteToEdit && nextProps.notes.noteToEdit){
            if(this.props.notes.noteToEdit.id !== nextProps.notes.noteToEdit.id){
                let edit = nextProps.notes.noteToEdit;
                this.setState({
                    category: edit.category,
                    title: edit.title,
                    private_comment: edit.private_comment,
                    public_comment: edit.public_comment,
                    priority: edit.priority,
                    dueDate: edit.due_date!==null?moment(edit.due_date).format('YYYY-MM-DD'):null
                });
            }
        }
    };


    renderCategories = () => {
        return this.props.visits.categories.map((cat, i) => {
            return <div onClick={() => this.setState({category: cat.id})} key={i}
                        style={{backgroundColor: this.state.category === cat.id ? cat.color : '#ffffff'}}
                        className={"category"}>{cat.title.toUpperCase()}</div>
        })
    };

    _handleChange = (prop, value) => {
        this.setState({[prop]: value});
    };

    _handleDateChange = (date) => {
        this.setState({ dueDate: date });
    };

    _notifyMandatory =  () => {
        swal({
            title: 'Formulario incompleto',
            text: 'Por favor, ingrese el título, la categoría y prioridad para continuar',
            type: 'error',
            showConfirmButton: false,
            showCancelButton: false,
            timer: 3000
        });
    };

    createNote = () => {
        let {title, public_comment, private_comment, category, priority, dueDate} = this.state;

        if(!(title && priority && category)){
            this._notifyMandatory();
            return false;
        }

        let formData = new FormData();
        formData.append("title", title);
        formData.append("public_comment", public_comment);
        formData.append("private_comment", private_comment);
        formData.append("category", category);
        formData.append("priority", priority);
        formData.append("station", this.props.stations.selectedStation.toString());
        if(dueDate!==null){
            formData.append("due_date", moment(dueDate).format('YYYY-MM-DD'));
        }

        this.setState({xhr: true});

        const create_note_url = `${urls.API_ROOT}/api/v1/station-notes/`;
        axios
            .post(create_note_url, formData, tokenHeader())
            .then((response) => {
                if(response.data){
                    this._postFiles(response.data.id, response.data.station);
                }
            })
            .catch(e => {
                this.setState({xhr: false});
                ajaxHandler(e);
            });
    };

    updateNote = () => {
        let edit = this.props.notes.noteToEdit;

        let {title, public_comment, private_comment, category, priority, dueDate} = this.state;

        if(!(title && priority && category)){
            this._notifyMandatory();
            return false;
        }

        this.setState({xhr: true});

        let formData = new FormData();
        formData.append("title", edit && title===''? edit.title: title);
        formData.append("public_comment", edit && public_comment===''? edit.public_comment: public_comment);
        formData.append("private_comment", edit && private_comment===''? edit.private_comment: private_comment);
        formData.append("category", edit && category===0? edit.category: category);
        formData.append("priority", priority);
        formData.append("station", this.props.stations.selectedStation.toString());
        if(dueDate!==null){
            formData.append("due_date", moment(dueDate).format('YYYY-MM-DD'));
        }

        const create_note_url = `${urls.API_ROOT}/api/v1/station-notes/${edit.id}/`;
        axios
            .patch(create_note_url, formData, tokenHeader())
            .then((response) => {
                if(response.data){
                    this._postFiles(response.data.id, response.data.station);
                }
            })
            .catch(e => {
                this.setState({xhr: false});
                ajaxHandler(e);
            });
    };

    _postFiles = (noteId, station) => {
        let {files} = this.state;
        if (files && files.length > 0) {
            let formData = new FormData();
            formData.append("file", files[0]);
            formData.append("note", noteId);
            formData.append("station", station);

            let headers = tokenHeader();
            headers['headers']['content-type'] = "multipart/form-data";

            const POST_NOTE_FILE_URL = `${urls.API_ROOT}/api/v1/station-file-notes/`;
            axios
                .post(POST_NOTE_FILE_URL, formData, headers)
                .then(() => {
                    let newFiles = files.slice(1);
                    this.setState({files: newFiles}, () => this._postFiles(noteId, station));
                })
                .catch(ajaxHandler);
        }else{
            this._onNoteSuccess();
        }
    };

    _onNoteSuccess = () => {
        swal({
            title: 'Nota registrada correctamente',
            text: "",
            type: 'success',
            showConfirmButton: false,
            showCancelButton: false,
            timer: 3000
        });
        this.setState({xhr: false});
        this.props.newNoteAdded();
        this.props.fetchNotes(this.props.stations.selectedStation);
    };

    showFileSection = () => {
        this.setState({showFileSection: true});
    };

    closeFileSection = () => {
        this.setState({showFileSection: false});
    };

    _onDrop = (files) => {
        let stateFiles = this.state.files;
        files.forEach(file => {
            let found = false;
            this.state.files.forEach(stateFile => {
                if (stateFile.name === file.name) {
                    found = true;
                }
            });
            if (!found) {
                stateFiles.push(file);
            }
        });
        this.setState({
            files: stateFiles
        });
    };

    _onDropRejected = () => {
        this.setState({file_failed: true});
    };

    _removeAttachedFile = (index) => {
        let newFiles = this.state.files.concat([]);
        newFiles.pop(index)
        this.setState({files: newFiles});
    };

    _deleteFile = (confirmed, id=null) => {
        if(!confirmed){
            this.setState({
                showDeleteModal: true,
                deleteFileId: id
            });
        }else{
            let {deleteFileId, deletedFileIds} = this.state;
            const DELETE_NOTE_FILE_URL = `${urls.API_ROOT}/api/v1/station-file-notes/${deleteFileId}/`;
            axios.delete(DELETE_NOTE_FILE_URL, tokenHeader())
                .then(() => {
                    let deletedFiles = deletedFileIds.concat([deleteFileId]);
                    this.setState({
                        deletedFileIds: deletedFiles,
                        showDeleteModal: false
                    });
                })
                .catch(e => {
                    this._closeModal();
                    ajaxHandler(e);
                });
        }
    };

    _closeModal = () => {
      this.setState({
          showDeleteModal: false,
          deleteFileId: null
      });
    };

    _closeSection = (confirm) => {

        if(confirm) {
            this.setState({files: []});
            this.props.newNoteAdded();
        }

        // Check changes before closing
        let {title, private_comment, public_comment, priority, category, files, dueDate} = this.state;
        let edit = this.props.notes.noteToEdit;

        if(edit){
            // Edited note
            if(
                title !== edit.title ||
                private_comment !== edit.private_comment ||
                public_comment !== edit.public_comment ||
                priority !== edit.priority ||
                dueDate !== edit.due_date ||
                category !== edit.category ||
                files.length > 0
            ){
                this.setState({showExitModal: true});
            }else{
                this.setState({files: []});
                this.props.newNoteAdded();
            }
        }else{
            if(
                title !== '' ||
                private_comment !== '' ||
                public_comment !== '' ||
                priority !== '' ||
                category !== '' ||
                files.length > 0
            ){
                this.setState({showExitModal: true});
            }else{
                this.setState({files: []});
                this.props.newNoteAdded();
            }
        }

    };

    render() {
        let dropZoneStyle = {
            width: '100%',
            height: '100px',
            border: "2px #bcbcbc dashed",
            borderRadius: "0",
            overflowY: "auto",
            backgroundColor: "#FBFBFB"
        };

        let dropZoneActive = {
            border: "2px #008443 solid",
            background: "#f7f7f7"
        };

        let dropZoneReject = {
            border: "2px #DD1D21 solid",
            background: "#fff",
            color: "rgba(0,0,0,0.1)"
        };

        let edit = this.props.notes.noteToEdit;
        let totalFiles = this.state.files.filter(file => file.is_active).length;
        if(edit && edit.files) totalFiles += edit.files.filter(file => file.is_active).length;

        let today = new Date();
        let tomorrow = new Date();
        console.log(edit);
        let body = (
            <div>
                {edit && this.props.mobile.isMobile &&
                <ActionButtons type={"edit"}/>}
                <Input
                    placeholder="Título"
                    className={"title-input"}
                    value={this.state.title}
                    onChange={(ev) => this._handleChange('title', ev.target.value)}
                    inputProps={{
                        'aria-label': 'Description',
                    }}
                />

                {edit.created_at &&
                <div className={"label"} style={{fontStyle:'italic'}}>Creada el {dateFormat(edit.created_at)}</div>
                }

                <FormControl fullWidth className={"input"}>
                    <div className={"label"}>Comentario de uso interno</div>
                    <InputBase className={"outlined-input"}
                               value={this.state.private_comment}
                               onChange={(ev) => this._handleChange('private_comment', ev.target.value)}
                               multiline rows={3}
                               placeholder={"Opcional"}/>
                </FormControl>

                <FormControl fullWidth className={"input"}>
                    <div className={"label"}>Comentario para empresario</div>
                    <InputBase className={"outlined-input"}
                               value={this.state.public_comment}
                               onChange={(ev) => this._handleChange('public_comment', ev.target.value)}
                               multiline rows={3}
                               placeholder={"Opcional"}/>
                </FormControl>

                <div className={"label"}>Categorías</div>
                {this.props.visits.categories &&
                <div className={"categories-section"}>
                    {this.renderCategories()}
                </div>}

                <Grid container spacing={8}>
                    <Grid item xs={6}>
                        <div className={"label"}>Prioridad</div>
                        <PrioritySelect priority={this.state.priority}
                                        changeAction={(priority) => this._handleChange('priority', priority)}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <div className={"label"}>Vencimiento</div>
                        <DatePicker
                            minDate={tomorrow.setDate(today.getDate() + 1)}
                            maxDate={new Date(today.setFullYear(today.getFullYear() + 1))}
                            value={this.state.dueDate}
                            format={'DD/MM/YYYY'}
                            cancelLabel={'Cancelar'}
                            clearable
                            clearLabel={"BORRAR"}
                            onChange={this._handleDateChange}
                            className={'date-input-field'}
                            minDateMessage={'La fecha debe ser una fecha futura'}
                            />
                    </Grid>
                </Grid>

                <Grid container spacing={8} className={'files-grid'}>
                    <Grid item xs={6}>
                        <div className={"files-btn"} onClick={this.showFileSection}>
                            <img src={downloadFile} className={"file-icon"} alt={"add-file"}/>
                            <div className={"btn-file-text"}>Adjuntos ({totalFiles})</div>
                        </div>
                    </Grid>
                    <Grid item xs={6}>
                        <div className={"attach-btn"} onClick={this.showFileSection}>
                            Cargar archivo
                        </div>
                    </Grid>
                </Grid>

                <div className={'text-center btn-containers'}>
                    {!this.state.xhr &&
                    <div>
                        <Button onClick={() => this._closeSection(false)} className={"cancel-btn"}>Cancelar</Button>
                        <Button onClick={edit ? this.updateNote : this.createNote} className={"accept-btn"}>Guardar</Button>
                    </div>
                    }
                    {this.state.xhr &&
                    <div>
                        <LoadingSpinner  width={50} />
                    </div>
                    }
                </div>
            </div>
        );

        if(this.state.showFileSection){
            body = (
                <div className={'attachments-section'}>
                    <div className={'att-title'}>
                        <img src={highest} alt={"Volver"} onClick={this.closeFileSection} />
                        <div className={'att-title-text'}>{this.state.title ? this.state.title : 'Volver'}</div>
                    </div>
                    <div className={'att-container'}>
                        <div className={'att-container-title'}>Adjuntos</div>
                        <div className={'att-container-files'}>
                            {edit && edit.files &&
                            edit.files.filter(file => (file.is_active && this.state.deletedFileIds.indexOf(file.id) === -1)).map((file, i) => {
                                let filename = file.file.split("/");
                                return (
                                    <div key={i} className={'att-container-file bold'}>
                                        <a href={file.file} target={'_blank'}>
                                            <img src={downloadFile} alt={'Descargar'} />
                                            {filename[filename.length - 1]}
                                        </a>
                                        <div className={'delete-file'} onClick={() => this._deleteFile(false, file.id)}>
                                            <img src={deleteFile} alt={'Eliminar'} />
                                        </div>
                                    </div>
                                )
                            })}
                            {this.state.files.map((file, i) => {
                                return (
                                    <div className={'att-container-file'} key={i}>
                                        {file.name}
                                        <div className={'delete-file'} onClick={() => this._removeAttachedFile(i)}>
                                            <img src={deleteFile} alt={'Eliminar'} />
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <div>
                        <Dropzone
                            style={dropZoneStyle}
                            multiple={true}
                            activeStyle={dropZoneActive}
                            rejectStyle={dropZoneReject}
                            maxSize={11000000}
                            onDropRejected={this._onDropRejected}
                            onDrop={(files) => this._onDrop(files)}>
                            <div className={'dropzone-hint'}>
                                <p>
                                    Arrastrar un archivo o clickear para examinar
                                </p>
                            </div>
                        </Dropzone>
                        <div className={'btn-containers text-center'}>
                            <Button onClick={this.closeFileSection} className={"accept-btn"}>Aceptar</Button>
                        </div>
                    </div>

                    {this.state.showDeleteModal &&
                    <Modal text={"¿Seguro que quiere eliminar este archivo adjunto?"}
                           accept={() => this._deleteFile(true)} cancel={this._closeModal}
                           open={this.state.showDeleteModal}/>
                    }
                </div>
            );
        }

        return (
            <div className={'newnote-section'} style={{borderTopColor: edit? '#F7D117':'#dd1d21'}}>
                {!this.state.xhr &&
                <Hidden mdDown>
                    <img src={cross} alt={"close"} className={"close-icon"} onClick={() => this._closeSection(false)}/>
                </Hidden>
                }
                {body}
                {this.state.showExitModal &&
                <Modal text={"Se registraron cambios que no se han guardado. ¿Desea descartarlos?"}
                       accept={() => this._closeSection(true)} cancel={() => this.setState({showExitModal: false})}
                       open={this.state.showExitModal}/>
                }
            </div>

        );
    }
}


const mapStateToProps = (state) => {
    return {
        user: state.user,
        visits: state.visits,
        notes: state.notes_actions,
        stations: state.stations,
        mobile: state.mobile
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({fetchNotes, newNoteAdded}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(NewNote);


// WEBPACK FOOTER //
// ./src/containers/site-visits/stationDetail/components/newNote/NewNote.js